import { useState } from 'react';
import clsx from 'clsx';
import { Button } from '../../../../../../../common/_custom';
import { caretRight } from '../../../../../../../assets/hostedassets';
import { AUDITOR_COMMENTS_LABEL } from '../../../../../../../utils/constants/commonConstants';
import { formatYear } from '../../useAuditorCommentsDrawer';
import { AUDITOR_COMMENTS_COLUMN_LABELS } from '../../constants';
import type { AuditorCommentsYearPanelProps } from '../../auditorCommentsDrawer.types';
import {
    AuditorDetails,
    QualificationBadge,
    AuditorCommentsContent,
    DirectorCommentsContent,
} from '../AuditorCommentsCells/AuditorCommentsCells';
import styles from './AuditorCommentsYearPanel.module.scss';

const AuditorCommentsYearPanel = ({ row, defaultExpanded = false }: AuditorCommentsYearPanelProps) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <div className={styles.Panel}>
            <Button
                type="button"
                className={styles.PanelHeader}
                aria-expanded={expanded}
                onClick={() => setExpanded((wasExpanded) => !wasExpanded)}
                text={
                    <span className={styles.PanelHeaderContent}>
                        <span className={styles.PanelHeading}>
                            <span className={styles.PanelYear}>{formatYear(row.year)}</span>
                            <QualificationBadge hasAdverseRemarks={row.reportHasAdverseRemarks} />
                        </span>
                        <img
                            src={caretRight}
                            alt=""
                            aria-hidden="true"
                            className={clsx(styles.Chevron, { [styles.ChevronExpanded]: expanded })}
                        />
                    </span>
                }
            />
            {expanded && (
                <>
                    <div className={styles.PanelField}>
                        <span className={styles.PanelFieldLabel}>{AUDITOR_COMMENTS_COLUMN_LABELS.AUDITOR_DETAILS}</span>
                        <AuditorDetails row={row} />
                    </div>
                    <div className={styles.PanelField}>
                        <span className={styles.PanelFieldLabel}>{AUDITOR_COMMENTS_LABEL}</span>
                        <AuditorCommentsContent row={row} showBadge={false} />
                    </div>
                    <div className={styles.PanelField}>
                        <span className={styles.PanelFieldLabel}>{AUDITOR_COMMENTS_COLUMN_LABELS.DIRECTOR_COMMENTS}</span>
                        <DirectorCommentsContent row={row} />
                    </div>
                </>
            )}
        </div>
    );
};

export default AuditorCommentsYearPanel;
